var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHamburgerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8457",
    "data-name": "Group 8457",
    transform: "translate(-325 -23)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3864",
    "data-name": "Rectangle 3864",
    width: 20,
    height: 2,
    rx: 1,
    transform: "translate(325 23)",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3865",
    "data-name": "Rectangle 3865",
    width: 14,
    height: 2,
    rx: 1,
    transform: "translate(325 29)",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3866",
    "data-name": "Rectangle 3866",
    width: 20,
    height: 2,
    rx: 1,
    transform: "translate(325 35)",
    fill: "#929292"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerIcon);
export default __webpack_public_path__ + "static/media/hamburger-icon.bc02b655a10f1c1243c635400c0f0ce3.svg";
export { ForwardRef as ReactComponent };